import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
    to: string,
    valid: boolean
}

const CustomNavLink: FC<Props> = ({ to, valid, children }) => {
    return (
        <React.Fragment>
        {
            valid ? 
            (
                <NavLink 
                    to={to} 
                    exact
                    activeClassName="active"
                >
                    {children}
                </NavLink>
            ) :
            (
                <span className="disable">{children}</span>
            )
        }
        </React.Fragment>
    );
};

export default CustomNavLink;